<template>
  <div class="taiwanTravelCard flex justify-between p-16 md:p-24 mb-24 border border-grey-lighter items-center" style="border-radius: 20px;">
    <div class="owl-checkbox-wrap">
      <label for="taiwanTravelCard">
        <input type="checkbox" id="taiwanTravelCard" v-model="isOnlyUseTaiwanTravel">
        <div class="owl-checkbox flex-no-shrink"></div>
        <span class="cursor-default leading-normal">
          {{ $t('taiwanTravelCard.title') }}
        </span>
      </label>
    </div>
    <div class="image-wrapper">
      <img class="w-full h-auto" src="@/assets/payment-ways/taiwan-travel.svg" alt="國旅卡" />
    </div>
  </div>
</template>
<script>
import { mapMutations, mapGetters } from 'vuex'
export default {
  name: 'TaiwanTravelCard',
  computed: {
    ...mapGetters({
      'order/isOnlyUseTaiwanTravel': 'order/isOnlyUseTaiwanTravel'
    }),
    isOnlyUseTaiwanTravel: {
      get () {
        return this['order/isOnlyUseTaiwanTravel']
      },
      set (val) {
        this.$store.commit('order/SET_TAIWAN_TRAVEL_CARD', val)
      }
    }
  },
  methods: {
    ...mapMutations([
      'order/SET_TAIWAN_TRAVEL_CARD'
    ])
  },
  watch: {
    isOnlyUseTaiwanTravel: {
      handler: function (val) {
        if (val) {
          window.dataLayer.push({
            event: 'order_travelcard'
          })
        }
      }
    }
  }
}
</script>
<style lang="sass" scoped>
.image-wrapper
  @apply bg-white
  width: 71px
  height: 45px
</style>
